import { getTablePartController } from '../../../../BaseEditor';
import { GridTemplate } from './styles';
import BodyComponent from './body';
import getCommandPanel from '../../../../BaseEditor/tablePart/commandPanels';
import HeaderComponent from './header';

const newRecordData = () => ({
  datefrom: (new Date()).toISOString().slice(0, 10),
  dateto: '2999-12-31',
  ratio: 1,
});

export default getTablePartController(
  GridTemplate,
  BodyComponent,
  newRecordData,
  getCommandPanel(),
  HeaderComponent,
);
